/**
 * Utility functions for the application.
 *
 * @since 2026-01-05
 */

import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines class names with Tailwind CSS conflict resolution.
 *
 * Uses clsx for conditional class handling and tailwind-merge
 * to properly merge Tailwind CSS classes without conflicts.
 *
 * @example
 * cn("px-4 py-2", "px-6") // => "py-2 px-6"
 * cn("bg-red-500", condition && "bg-blue-500") // conditional classes
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
